import {Routes, Route} from "react-router-dom"
import Home from "./Home";
import {fallDown as Menu} from 'react-burger-menu';
import Clips from "./Clips";
import Art from "./Art";
import ScrollToTop from "react-scroll-to-top";

const styles = {
    bmBurgerButton: {
        position: 'fixed',
        width: '36px',
        height: '30px',
        left: '36px',
        top: '36px'
    },
    bmBurgerBars: {
        background: '#373a47'
    },
    bmBurgerBarsHover: {
        background: '#a90000'
    },
    bmCrossButton: {
        height: '24px',
        width: '24px'
    },
    bmCross: {
        background: '#bdc3c7'
    },
    bmMenuWrap: {
        position: 'fixed',
        height: '100%'
    },
    bmMenu: {
        background: '#003B1B',
        padding: '2.5em 1.5em 0',
        fontSize: '1.15em'
    },
    bmMorphShape: {
        fill: '#373a47'
    },
    bmItemList: {
        color: '#b8b7ad',
        padding: '0.8em',
        height: '95%'
    },
    bmItem: {
        display: 'inline-block'
    },
    bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)'
    }
}

export default function App() {
    return (
        <div className='App' id="outer-container">
            <Menu pageWrapId={"page-wrap"} outerContainerId={"outer-container"} styles={styles}>
                <a href="/">Links</a>
                <a href="/clips">Clips</a>
                <a href="/art">Art Gallery</a>
            </Menu>
            <main id="page-wrap" >
                <Routes>
                    <Route path='/' element={<Home/>}/>} />
                    <Route path='/clips' element={<Clips />} />
                    <Route path='/art' element={<Art />} />
                </Routes>
                <ScrollToTop smooth color='#003b1b' />
            </main>
        </div>
    );
}